import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/afterSales",
  name: "afterSales",
  component: function component() {
    return import("../../../views/afterSales/afterSalesList.vue");
  },
  meta: {
    title: "售后",
    foot: true
  }
}, {
  path: "/afterSalesDetail/:refundId",
  name: "afterSalesDetail",
  component: function component() {
    return import("../../../views/afterSales/afterSalesDetail.vue");
  },
  meta: {
    title: "售后详情",
    foot: true
  }
}, {
  path: "/applyAfterSales/:orderId",
  name: "applyAfterSales",
  component: function component() {
    return import("../../../views/afterSales/applyAfterSales.vue");
  },
  meta: {
    title: "申请售后",
    foot: true
  }
}, {
  path: "/modifyAfterSales/:refundId",
  name: "modifyAfterSales",
  component: function component() {
    return import("../../../views/afterSales/modifyAfterSales.vue");
  },
  meta: {
    title: "修改申请",
    foot: true
  }
}];